<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/repair/part"
        :tableData.sync="tableData"
        :columns="columns"
		    :searchParams="searchData">
        <template #handle="{ row }">
          <el-button type="text" @click="handleRow(row, 'edit')">编辑</el-button>
          <el-button type="text" size="mini" @click="handleRow(row, 'del')">删除</el-button>
        </template>
      </BaseTable>
            <!-- 修改 -->
        <el-drawer title="修理厂" size="50%" :visible.sync="isShowDrawer" direction="rtl">
          <!-- <BaseDialog :visible.sync="isShowDrawer" title="服务条款" @confirm="onSubmit"  width = "50%"> -->
              <div style="padding: 30px;">
                <div style="flex"></div>
                <el-form labelWidth="100px" size="medium">
                  <el-form-item label="名称">
                    <el-input  v-model="formData.name" required></el-input>
                  </el-form-item>
                  <el-form-item label="基础金额">
                    <el-input  v-model="formData.money" required></el-input>
                  </el-form-item>
                  <el-form-item class="from-item--30" label="状态" prop="claims_type">
                    <el-select v-model="formData.status" filterable>
                      <el-option label="禁用" value="0"></el-option>
                      <el-option label="启用" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form>
              </div>
        </el-drawer>
        <el-dialog :visible.sync="preVisible">
          <img width="100%" :src="preImageUrl" alt="" />
        </el-dialog>
        <!-- </BaseDialog> -->
    </div>
  </div>
</template>
<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Repairshop",
  comments: {},
  data() {
    return {
      searchData: {},
      tableData: [],
      isShowDrawer:false,
      formData:{},
      id:0,
    };
  },
  computed: {
    searchFormOption,
    columns
  },
  created() {
    
  },
  methods: {
    async onSubmit(){
      if(this.formData.name == '' || !this.formData.name){
        this.$message.warning("名称不能为空");
        return;
      }
      if(this.formData.status == '' || !this.formData.status){
        this.$message.warning("请选择状态");
        return;
      }
      let query = await this.$api.post(
        "/admin/repair/partsave",
        { ...this.formData , id: this.id || 0},
      );
      if(query.code == 10000){
        this.isShowDrawer = false;
        this.handleSearch();
        this.id = 0
      }
    },
    // 打开新增
    add() {
      this.id = 0
      this.formData = {};
      this.isShowDrawer = true;
    },
    handleRow(row, k) {
      switch (k) {
        case "edit":
          this.handleEdit(row);
          break;
        case "del":
          this.handleDel(row);
          break;
        default:
          break;
        }
    },
    // 点击编辑
    async handleEdit({ id }) {
      this.id = id
      const res = await this.$api.post("/admin/repair/getPartDetails", {
        id: id,
      });
      this.formData = res.data.data;
      this.storePhoto = res.data.storePhoto;
      this.isShowDrawer = true;
    },
   // 点击删除
   handleDel({ id }) {
      this.$confirm(`是否确认删除【ID${id}】项目, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post(
            "/admin/repair/partdel",
            { id: id },
            "删除"
          );
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
  },
};
</script>

<style scoped>
.el-drawer{
  width: 50%;
}
</style>